export const PageNameConstant = {
  fleetList: "Fleet List",
  replacementSchedule: "Replacement Schedule",
  maintenanceAnalysis: "Maintenance Analysis",
  fuelAnalysis: "Fuel Analysis",
  fundingNewVehicle: "Funding/New Vehicle",
  analysisResult: "Analysis Results",
};
